import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ApiGetApplicationVersions } from "../../../stores/api/application/actions";
import Navigation from "../../components/Navigation/Navigation";
import { Paper, styled, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import { FromStore } from "../../../helpers/Store";
import { CenteredContainer, StyledTableCellServerVersionPage } from "../../../style/GlobalsComponentsStyled";
import BackButtonWithTitle from "../../components/BackButtonWithTitle/BackButtonWithTitle";
import { useAppDispatch } from "../../../helpers/UseAppDispatch";
import { ApplicationVersionData } from "../../../api/dtos/application/ApplicationVersionResponse";

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    background: 'linear-gradient(to top right, #CDC7E5 0%, #A92FFB 28%, #891CFB 59%, #2F27CE 100%)',
    padding: '2px',
    borderRadius: theme.spacing(1),
    maxWidth: 'fit-content',
}));

const VersionHistoryPage: React.FC = () => {
    const { applicationId } = useParams<{ applicationId: string }>();
    const versions: ApplicationVersionData[] = FromStore((state) => state.apis.applications.versions);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(ApiGetApplicationVersions(Number(applicationId)))
    }, [])

    return (
        <>
            <Navigation />
            <CenteredContainer className="main_content">
                <BackButtonWithTitle title="Version History" />
                <>
                    <StyledTableContainer>
                        <Paper sx={{ backgroundColor: '#1C1D2B', display: "table", width: "100%" }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCellServerVersionPage>Version</StyledTableCellServerVersionPage>
                                        <StyledTableCellServerVersionPage>Date Deployed</StyledTableCellServerVersionPage>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {versions.map((version, index) => (
                                        <TableRow key={index}>
                                            <StyledTableCellServerVersionPage>{version.version}</StyledTableCellServerVersionPage>
                                            <StyledTableCellServerVersionPage>{new Date(version.dateDeployed).toLocaleDateString()}</StyledTableCellServerVersionPage>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Paper>
                    </StyledTableContainer>
                </>
            </CenteredContainer>
        </>
    );
};

export default VersionHistoryPage;
